import { isString } from '../../utils/lodash-min';

export class MemeSourceImage {
    public memeName: string;
    public sourceImageUrl: string;
    public thumbImageUrl: string;
    constructor(name: string, srcImage: HTMLImageElement | string) {
        this.memeName = name && name.replace('&#039;', '\'');
        if (isString(srcImage)) {
            this.sourceImageUrl = '/meme/src/' + srcImage;
            this.thumbImageUrl = '/meme/thumb/thumb-' + srcImage;
        } else if (srcImage instanceof HTMLImageElement) {
            this.sourceImageUrl = srcImage.src;
            this.thumbImageUrl = srcImage.src;
        }
    }
}
